<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="partnoAlt"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Area</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>              
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <!--<v-btn @click="listPartnoAlt()" color="primary" dark class="mb-2">Seach</v-btn> -->
                    <v-spacer></v-spacer>              
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>       
               <template>
                    <v-row justify="center">
                        <v-dialog v-model="dialog" persistent max-width="900px">
                        <template v-slot:activator="{ on }" >
                            <v-btn color="primary" dark v-on="on">New item</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                           
                            <v-card-text>                            
                            <v-container>                              
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                </v-flex>   
                                <v-row>
                                
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field maxlength="30" v-model="area" label="Area" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field maxlength="50" v-model="description" label="Description" required></v-text-field>
                                    </v-col>                                                                   
                                                                                                
                                </v-row>                            
                            </v-container>
                            <small>*indicates required field</small>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                <v-btn
                                    :disabled="dialogLoading"
                                    :loading="dialogLoading"
                                    color="blue darken-1" text @click="save"
                                    >
                                    Save
                                </v-btn>
                            
                           
                           <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    Saving, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                                </v-dialog>            

                            </v-card-actions>
                        </v-card>
                        </v-dialog>
                    </v-row>
                
                    <v-row>
                        <v-dialog v-model="adModal" persistent max-width="290px">
                        <v-card>
                            <v-card-title class="headline" v-if="adAccion == 1">Active Item?</v-card-title>
                            <v-card-title class="headline" v-if="adAccion == 2">Desactive Item?</v-card-title>
                            <v-card-text>
                                Are you sure to
                                <span v-if="adAccion==1">Activate </span>
                                <span v-if="adAccion==2">Deactivate </span>
                                this area {{adName}} ?
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activateDesactivateClose">
                                    Cancel
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activate">
                                    Activate
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="deactivate">
                                    Deactivate
                                </v-btn>
                                
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    </v-row>
                
                </template>

                 

            </v-toolbar>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.ID">
                            <td>
                                <div >  
                                    <div >                                  
                                        <v-icon small class="mr-2" @click="editItem(item)">
                                            edit
                                        </v-icon>
                                        <template v-if="item.condition">
                                            <v-icon small class="mr-2" @click="activeDesactiveItem(2,item)">
                                                block
                                            </v-icon>
                                        </template>
                                        <template v-else="item.condition">
                                            <v-icon small class="mr-2" @click="activeDesactiveItem(1,item)">
                                                check
                                            </v-icon>
                                        </template>
                                    </div>
                                </div>                                                                                               
                            </td>                  
                                                        
                            <td class="text-xs-right">{{item.area}} </td>
                            <td class="text-xs-right">{{item.description}} </td>    
                            
                            <td class="text-xs-right">                                                        
                                <div v-if="item.condition">
                                    <span class="blue--text">Active</span>                                    
                                </div>
                                <div v-else>
                                <span class="red--text">Inactive</span>
                                </div>                                
                            </td>                        
                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                           

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  partnoAlt:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },                        
                       // { text: 'ID', value: 'id', sortable: false },
                        { text: 'Area', value: 'area', sortable: false },
                        { text: 'Description', value: 'description', sortable: false },                        
                        { text: 'State', value: 'condition', sortable: false }                      
                    ],
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                  
                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 
                                      
                   
                    valida:0,
                    validaMensaje:[],

                    adModal: 0,
                    adAccion: 0, 
                    adName: '',
                    adId: '',

                    area: '',
                    description: '' 

                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Area' : 'Edit Area'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listArea();
            //this.havePriviges();     
        },

         methods: { 
           //   havePriviges() {
            //    this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            //} ,   

             exitApp(){
                this.$store.dispatch("exit");
            },              
            listArea(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_area/List';
                //if (!me.search){
                //    url ='api/dell_mod_s_partno_alt/List';
                //}
                //else{
                //    url ='api/Invoices/ListFilter/' + me.search;
                //}
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id_area;  
                this.area= item.area; 
                this.description= item.description; 
                this.condition= item.condition;
                      
                this.editedIndex=1;
                this.dialog = true
            },

            activeDesactiveItem (accion, item) {
                this.adModal= 1;
                this.adName = item.area;
                this.adId = item.id_area;

                if (accion == 1){
                   this.adAccion = 1;
                } else if (accion == 2){
                    this.adAccion = 2;
                } else{
                   this.adModal= 0;
                }                
            },

            activateDesactivateClose(){
                this.adModal = 0;
            },

            activate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Activate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listArea();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },
            deactivate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Desactivate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listArea();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 
                this.area= "";
                this.description= "";
                this.condition= ""; 
                  

                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               
                if (this.validar() > 0)  {                                      
                     return;   
                }                 
                
                if (this.editedIndex > -1) {                   
                   //Code for Edit Mode
                   this.dialogLoading = true;
                   let me=this;

                     let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };

                   //let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_area/Update',{                                                   
                        'id_area':me.id,                                         
                        'area': me.area,
                        'description': me.description                            
                    },configuration).then(function(response){
                        me.close();
                        me.listArea();
                        me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);                   

                } else {                    
                    //Code for Save                   
                   if (this.validar()){
                       return;
                   }

                    let me=this; 
                    let header={
                        "x-token": this.$store.state.token,
                        "Authorization": "Bearer " + this.$store.state.token                       
                        };   
                    //let header={"Authorization": "Bearer " + this.$store.state.token};
                    let configuration = {headers : header };
                    this.dialogLoading = true;         
                    axios.post('api/dell_sop_s_area/CreateArea',{                                                   
                            'area': me.area,
                             'description': me.description     
                    },configuration).then(function(response){
                        console.log('Save');
                        me.close();
                        me.listArea();
                        me.clean();
                        if (response.data.msg == 'Token no valid')
                        {
                            me.exitApp();
                        }
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        this.validaMensaje.push('Area is already registered.')
                    );  
                   
                }               
            },
           
            validar() {
                console.log('Funcion de validar');
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.area){
                     this.validaMensaje.push('Input area');
                 }   
                 if (!this.description){
                     this.validaMensaje.push('Input description');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>